import React, { FC } from 'react';
import Link from 'next/link';
import DownloadLg from '../components/icons/DownloadLg.svg';

interface Props {
  text: string;
  link: string;
}

const DownloadButton: FC<Props> = ({ text, link }) => {
  return (
    <Link href={link}>
      <a>
        <div className='flex cursor-pointer text-primary hover:text-primary-hover'>
          <div className='text-lg font-semibold text-normal'>{text}</div>
          <div className='mt-1 ml-2'>
            <DownloadLg className='fill-current' />
          </div>
        </div>
      </a>
    </Link>
  );
};

export default DownloadButton;
